import * as React from 'react';
export const IcGpon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.5 13a2.691 2.691 0 00-.7.11l-4.7-5.37a2.5 2.5 0 10-2.2 0l-4.7 5.37a2.691 2.691 0 00-.7-.11A2.5 2.5 0 108 15.5c0-.383-.093-.76-.27-1.1L11 10.66v5.55a2.5 2.5 0 102 0v-5.55l3.27 3.74a2.39 2.39 0 00-.27 1.1 2.5 2.5 0 102.5-2.5z'
      fill='currentColor'
    />
  </svg>
);
